import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { UserActions } from './user-actions-enum';
import { useActionMenuComposable } from '@shared/components/action-menu/action-menu-composable';

export const useUserActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const actionMenuHelper = useActionMenuComposable();
  const userActionMenuItems: ActionMenuItem[] = [
    {
        title:'Details',
        icon:'info',
        route:'/user-management/users',
        validPermission: validatePermission.canManageUsers(),
        action: UserActions.PageChange,
    },
    {
        title:'Deactivate',
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/user-management/users',
        validPermission: validatePermission.canManageUsers(),
        action: UserActions.Toggled,
    },
  ];
  return{
    userActionMenuItems
  }
};